import { render, staticRenderFns } from "./studentRecordSearchHistory.vue?vue&type=template&id=00dbb1d2&scoped=true"
import script from "./studentRecordSearchHistory.vue?vue&type=script&lang=js"
export * from "./studentRecordSearchHistory.vue?vue&type=script&lang=js"
import style0 from "./studentRecordSearchHistory.vue?vue&type=style&index=0&id=00dbb1d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dbb1d2",
  null
  
)

export default component.exports